const countLocalization = {
  itemSingular: 'item',
  itemPlural: 'items',
  visualMore: (count: string) => `+${count} more`,
  visualCompact: (count: string) => `+${count}`,
  accessibleMore: (count: string, itemLabel: string) => `${count} more ${itemLabel}`,
}

export const menuLocalization = {
  itemSingular: 'item',
  itemPlural: 'items',
  showMore: (count: string, itemLabel: string) => `Show ${count} more ${itemLabel}`,
  fallbackItem: (itemLabel: string, index: string) => `${itemLabel} ${index}`,
}

export default countLocalization
